import { render } from "./App.vue?vue&type=template&id=15148b19&scoped=true"
import script from "./App.vue?vue&type=script&lang=true"
export * from "./App.vue?vue&type=script&lang=true"

import "./App.vue?vue&type=style&index=0&id=15148b19&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15148b19"]])

export default __exports__